module.exports = {"index-login-title":"Ynlogge Mijn Arriva Flow","info-not-registered":"Noch net oanmeld foar Arriva Flow?","info-activation-link":"Aktivearje dyn akkount op MijnArriva","invalid-customer-type-notification-first":"Bist oanmeld mei in akkount dat noch net aktivearre is foar Arriva Flow. Meld dy ôf fia ”Utlogge” om dy wer oan te melden mei in Arriva Flow akkount.","invalid-customer-type-notification-second":"Hast noch gjin akkount dat aktyf is foar Arriva Flow? Brûk dan de link ”Aktivearje dyn akkount op MijnArriva” om troch te gean nei de Arriva Flow aktivaasje side."}


//////////////////
// WEBPACK FOOTER
// ./src/locale/fy/abt-payment.json
// module id = gZgG
// module chunks = 1